import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { RootState } from "app/store";
import { ApiResponse } from "models";

const initialState: any = {
  imgloading: false,
  loading: false,
  data: {},
  customerListData: {},
  customerListSuccess: false,
  customerListMessage: "",
  addBrandMessage: "",
  message: "",
  success: false,
  imageUrl: "",
  updateMessage: "",
  addBrandLoading: false,
  updateBrandMessage: "",
  updateBrandLoading: false,
  brandListData: [],
  brandListSuccess: false,
  brandListMessage: false,
};

const brandLocationSlice = createSlice({
  name: "brandLocation",
  initialState,
  reducers: {
    getBrandLocation(state, action: PayloadAction<ApiResponse>) {
      state.loading = true;
      state.message = "";
    },
    getBrandLocationSuccess(state, action: PayloadAction<any>) {
      state.loading = false;
      state.data = action.payload;
      state.success = action.payload.success;
    },
    getBrandLocationFailed(state, action: PayloadAction<ApiResponse>) {
      state.loading = false;
      state.data = {};
      state.message = action.payload.message;
      state.success = action.payload.success;
    },
    addBrandLocation(state, action: PayloadAction<ApiResponse>) {
      state.addBrandLoading = true;
      state.addBrandMessage = "";
    },
    addBrandLocationSuccess(state, action: PayloadAction<ApiResponse>) {
      state.addBrandLoading = false;
      state.addBrandMessage = action.payload.message;
      state.success = action.payload.success;
    },
    addBrandLocationFailed(state, action: PayloadAction<ApiResponse>) {
      state.addBrandLoading = false;
      state.addBrandMessage = action.payload.message;
      state.success = action.payload.success;
    },
    updateBrandLocation(state, action: PayloadAction<ApiResponse>) {
      state.updateBrandLoading = true;
      state.updateBrandMessage = "";
    },
    updateBrandLocationSuccess(state, action: PayloadAction<ApiResponse>) {
      state.updateBrandLoading = false;
      state.updateBrandMessage = action.payload.message;
      state.success = action.payload.success;
    },
    updateBrandLocationFailed(state, action: PayloadAction<ApiResponse>) {
      state.updateBrandLoading = false;
      state.updateBrandMessage = action.payload.message;
      state.success = action.payload.success;
    },
    deleteBrandLocation(state, action: PayloadAction<ApiResponse>) {
      state.deleteLoading = true;
      state.deleteMessage = "";
    },
    deleteBrandLocationSuccess(state, action: PayloadAction<ApiResponse>) {
      state.deleteLoading = false;
      state.deleteMessage = action.payload.message;
      state.success = action.payload.success;
    },
    deleteBrandLocationFailed(state, action: PayloadAction<ApiResponse>) {
      state.deleteLoading = false;
      state.deleteMessage = action.payload.message;
      state.success = action.payload.success;
    },
    getCustomerList(state, action: PayloadAction<ApiResponse>) {
      state.customerListLoading = true;
      state.customerListMessage = "";
    },
    getCustomerListSuccess(state, action: PayloadAction<ApiResponse>) {
      state.customerListLoading = false;
      state.customerListData = action.payload.CustomerData;
      state.customerListSuccess = action.payload.success;
    },
    getCustomerListFailed(state, action: PayloadAction<ApiResponse>) {
      state.customerListLoading = false;
      state.customerListMessage = action.payload.message;
      state.customerListSuccess = action.payload.success;
    },
    getBrandList(state, action: PayloadAction<ApiResponse>) {
      state.customerListLoading = true;
      state.customerListMessage = "";
    },
    getBrandListSuccess(state, action: PayloadAction<ApiResponse>) {
      state.customerListLoading = false;
      state.brandListData = action.payload.brandName;
      state.customerListSuccess = action.payload.success;
    },
    getBrandListFailed(state, action: PayloadAction<ApiResponse>) {
      state.customerListLoading = false;
      state.customerListMessage = action.payload.message;
      state.customerListSuccess = action.payload.success;
    },
    clearData(state) {
      state.loading = false;
      state.message = "";
      state.success = false;
      state.addBrandLoading = false;
      state.addBrandMessage = "";
      state.updateMessage = "";
      state.deleteMessage = "";
      state.imageUrl = "";
      state.updateBrandMessage = "";
      state.updateBrandLoading = false;
      state.deleteMessage = "";
      state.deleteLoading = false;
      state.brandListLoading = false;
      state.brandListMessage = "";
    },
  },
});

//Actions
export const brandLocationActions = brandLocationSlice.actions;

//Selectors
export const getBrandsLocationData = (state: RootState) =>
  state.brandLocation.data;
export const getBrandLocationDataLoad = (state: RootState) =>
  state.brandLocation.loading;
export const addBrandIsLoading = (state: RootState) =>
  state.brandLocation.addBrandLoading;
export const addBrandIsMessage = (state: RootState) =>
  state.brandLocation.addBrandMessage;
export const CustomerListData = (state: RootState) =>
  state.brandLocation.customerListData;
export const updateLocationMessage = (state: RootState) =>
  state.brandLocation.updateBrandMessage;
export const updateLocationLoading = (state: RootState) =>
  state.brandLocation.updateBrandLoading;
export const deleteBrandLoad = (state: RootState) =>
  state.brandLocation.deleteLoading;
export const deleteBrandMsg = (state: RootState) =>
  state.brandLocation.deleteMessage;
export const brandListData = (state: RootState) =>
  state.brandLocation.brandListData;

//Reducers
const brandLocationReducer = brandLocationSlice.reducer;
export default brandLocationReducer;
